import './LatestCard.css';
import SlCard from '@shoelace-style/shoelace/dist/react/card/index.js';
import SlIcon from '@shoelace-style/shoelace/dist/react/icon/index.js';
import SlTooltip from '@shoelace-style/shoelace/dist/react/tooltip';
import { useNavigate, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useApi } from './useApi';

export default function LatestCard(props) {
    const { authPost, authDelete } = useApi();
    const [isLiked, setIsLiked] = useState(props.isLike || false);
    const [isDisliked, setIsDisliked] = useState(props.isDislike || false);
    const [copyTooltipText, setCopyTooltipText] = useState("Copy AI Summary");
    const navigate = useNavigate();
    
    // Sync state when props change (e.g., after API response)
    useEffect(() => {
        setIsLiked(props.isLike || false);
    }, [props.isLike]);
    
    useEffect(() => {
        setIsDisliked(props.isDislike || false);
    }, [props.isDislike]);
    
    // Use userId from props (from auth context)
    const userId = props.userId;
    const apiBaseUrl = process.env.REACT_APP_API_URL;
    const feedbackApi = `${apiBaseUrl}/userfeedback`;

    async function handleLike() {
        try {
            // If already liked, DELETE to remove the like
            if (isLiked) {
                const response = await authDelete(`${feedbackApi}/${props.id}`);
                
                if (response.ok) {
                    setIsLiked(false);
                    console.log("Like feedback removed successfully");
                } else {
                    console.error("Failed to remove like feedback:", response.status);
                }
            } else {
                // POST to create like
                const response = await authPost(feedbackApi, {
                    userId: userId,
                    articleId: props.id,
                    feedbackType: "like"
                });
                
                if (response.ok) {
                    setIsLiked(true);
                    setIsDisliked(false);
                    console.log("Like feedback submitted successfully");
                } else {
                    console.error("Failed to submit like feedback:", response.status);
                }
            }
        } catch (error) {
            console.error("Error with like feedback:", error);
        }
    }

    async function handleDislike(){
        // If already disliked, DELETE to remove the dislike
        if (isDisliked) {
            try {
                const response = await authDelete(`${feedbackApi}/${props.id}`);
                
                if (response.ok) {
                    setIsDisliked(false);
                    console.log("Dislike feedback removed successfully");
                } else {
                    console.error("Failed to remove dislike feedback:", response.status);
                }
            } catch (error) {
                console.error("Error removing dislike feedback:", error);
            }
        } else {
            // Open modal to submit dislike with reasons
            props.onDislikeClick({
                cardId: props.cardId,
                id: props.id,
                title: props.title,
                description: props.description,
                sourceUrl: props.sourceUrl,
                onDislikeSubmit: () => {
                    setIsDisliked(true);
                    setIsLiked(false);
                }
            })
        }
    }

    function handleCopyAiSummary(e) {
        e.stopPropagation();
        navigator.clipboard.writeText(props.rawData.aiSummary || '')
            .then(() => {
                setCopyTooltipText("AI Summary copied");
            })
            .catch(err => console.error('Failed to copy AI Summary:', err));
    }

    function resetCopyTooltip() {
        setCopyTooltipText("Copy AI Summary");
    }

    function handleHeaderClick() {
        // Use rawData if available, otherwise construct minimal record object
        const record = props.rawData || {
            id: props.id,
            title: props.title,
            sourceUrl: props.sourceUrl,
            aiSummary: props.description
        };
        navigate(`/details/${props.id}`, { state: { record: record } });
    }

    return <div style={{ height: '180px' }}>

        <SlCard className="cds-card-header-bar cds-card-footer-bar cds-card-image-aspect-4to3 cds-card-variant-brand">
            <div className="card-header" slot="header" >
                <Link 
                    to={`/details/${props.id}`} 
                    state={{ record: props.rawData || { id: props.id, title: props.title, sourceUrl: props.sourceUrl, aiSummary: props.description } }}
                    className="card-header-link"
                >
                    <h3 style={{ color: "#461e96", cursor: "pointer" }}>
                        {props.title}
                    </h3>
                </Link>
                <div className="card-icons">
                    <SlTooltip placement="top" hoist={true} content="Click the Like button if you think the information in the article is accurate, relevant, and useful.">
                        <SlIcon
                            onClick={handleLike}
                            label="Like"
                            style={{ cursor: "pointer", height: "16px", width: "16px", fontWeight: "bold", color: isLiked ? "#461e96" : "black", marginRight: "7px" }}
                            size="2xl"
                            src={isLiked ? "/Icons/Like_Active.svg" : "/Icons/Like.svg"}
                        />
                    </SlTooltip>
                    <SlTooltip placement="top" hoist={true} content="Click to provide feedback if you don't think information in the article is accurate, relevant, and useful.">
                        <SlIcon
                            onClick={handleDislike}
                            label="Dislike"
                            style={{ cursor: "pointer", height: "16px", width: "16px", marginRight: "7px", fontWeight: "bold", color: isDisliked ? "#461e96" : "black" }}
                            size="2xl"
                            src={isDisliked ? "/Icons/Dislike_Active.svg" : "/Icons/Dislike.svg"}
                        />
                    </SlTooltip>
                    <SlTooltip placement="top" hoist={true} content={copyTooltipText}>
                        <SlIcon 
                            onClick={handleCopyAiSummary}
                            onMouseEnter={resetCopyTooltip}
                            label="Copy AI Summary"
                            style={{ cursor: "pointer" }}
                            src="/Icons/common-file-double-2.svg"
                        />
                    </SlTooltip>
                </div>
            </div>
            <div className="card-description-content">{props.description}</div>
        </SlCard>
    </div>
}